/**
 * package: com.inq.flash.client.chatskins
 * class: XTrace
 * root Object
 * @constructor
 */
com.inq.flash.client.chatskins.XTrace = function() {};
$hxClasses['com.inq.flash.client.chatskins.XTrace'] = com.inq.flash.client.chatskins.XTrace;
/** @private @type {Array} */
com.inq.flash.client.chatskins.XTrace.__name__ = ["com","inq","flash","client","chatskins","XTrace"];

/**
 * redirection
 *
 * $type TFun([],TEnum(Bool,[]))
 * public static function redirection():Bool
 * @public
 * @static
 * @return {boolean}
 */
com.inq.flash.client.chatskins.XTrace.redirection = function() {
	haxe.Log.trace = com.inq.flash.client.chatskins.XTrace.sysTrace;
	return true;
};


/**
 * setRedirection
 *
 * $type TFun([],TEnum(Void,[]))
 * public static function setRedirection()
 * @public
 * @static
 * @return {void}
 */
com.inq.flash.client.chatskins.XTrace.setRedirection = function() {
	haxe.Log.trace = com.inq.flash.client.chatskins.XTrace.sysTrace;
	haxe.Log.trace("",{ fileName : "XTrace.hx", lineNumber : 34, className : "com.inq.flash.client.chatskins.XTrace", methodName : "setRedirection"});
};


/**
 * sysTrace
 *
 * $type TFun([{ name => v, t => TDynamic(null), opt => false },{ name => inf, t => TType(haxe.PosInfos,[]), opt => true }],TEnum(Void,[]))
 * private static function sysTrace( v : Dynamic, ?inf : haxe.PosInfos )
 * @private
 * @static
 * @param {null}  v 
 * @param {haxe.PosInfos}  inf 
 * @return {void}
 */
com.inq.flash.client.chatskins.XTrace.sysTrace = function(v,inf) {
	/** @type {string} */
	var txt = "[" + inf.fileName + ":" + inf.lineNumber + " " + inf.methodName + "] " + Std.string(v);
};


/**
 * StackTrace
 *
 * $type TFun([{ name => err, t => TDynamic(null), opt => false },{ name => hdr, t => TInst(String,[]), opt => true }],TEnum(Void,[]))
 * public static function StackTrace( err:Dynamic, ?hdr:String):Void
 * @public
 * @static
 * @param {null}  err 
 * @param {string}  hdr 
 * @return {void}
 */
com.inq.flash.client.chatskins.XTrace.StackTrace = function(err,hdr) {
	if(hdr == null) hdr = "WARNING:";
	/** @type {string} */
	var st = "";
	/** @type {string} */
	var erMsg = err.message;
	/** @type {string} */
	var errString = err.toString();
	haxe.Log.trace(hdr + " " + st,{ fileName : "XTrace.hx", lineNumber : 137, className : "com.inq.flash.client.chatskins.XTrace", methodName : "StackTrace"});
};

/** @type {com.inq.flash.client.chatskins.XTrace} */
com.inq.flash.client.chatskins.XTrace.prototype.__class__ = com.inq.flash.client.chatskins.XTrace;
